// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"103793cd","424":"84117cf2","592":"b59b40fc","748":"bebd293c"}[chunkId] + ".chunk.js";
};